import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { Contact } from "@models";

export interface New_ContactsState {
	contacts: Contact[];
	areLoaded: boolean;
}

const initialState: New_ContactsState = {
	contacts: [], // TODO_NEW Type when components are refactored
	areLoaded: false
};

@Injectable({
	providedIn: "root"
})
export class New_ContactsStateService extends StateService<New_ContactsState> {
	constructor() {
		super(initialState);
	}

	public getContacts(): Observable<New_ContactsState> {
		return this.select((state) => state);
	}

	public areContactsLoaded(): boolean {
		return this.state.areLoaded;
	}

	public setContacts(contacts: Contact[]): void {
		this.setState({ contacts: contacts, areLoaded: true });
	}

	public addContact(contact: Contact): void {
		this.setState({ contacts: [...this.state.contacts, contact], areLoaded: this.state.areLoaded });
	}

	public reloadContacts(): void {
		this.setState({ ...this.state, areLoaded: false });
	}
}
